import { localeLocation } from './router.utils'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (Vue: any) => {
  const instance = localeLocation
  const propName = 'localeLocation'
  Vue[propName] = instance
  Vue.prototype[propName] = instance
}
